/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Deal_UpdateInputs */

const cs_audit_key_deal_update = /** @type {(inputs: Audit_Key_Deal_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obchod upraven`)
};

const en_audit_key_deal_update = /** @type {(inputs: Audit_Key_Deal_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal updated`)
};

/**
* | output |
* | --- |
* | "Deal updated" |
*
* @param {Audit_Key_Deal_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_deal_update = /** @type {((inputs?: Audit_Key_Deal_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Deal_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_deal_update(inputs)
	return cs_audit_key_deal_update(inputs)
});